import React from 'react';
import palette from '../../color-palette';

interface NonGlutenProps {
  darkMode: boolean;
}

const NonGluten = ({ darkMode, ...props }: NonGlutenProps) => {
  const {
    primary: { main },
    common: { white },
  } = palette;

  return (
    <svg
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.92 18.54a10.33 10.33 0 0 1-.56-9.81 9.22 9.22 0 0 1 1.7-2.25 11.2 11.2 0 0 1 2.62-2.16c2.26-1.24 6.08-.93 8.5-.44 12.06 2.45 9.55 23.58-3.22 20.56-2.24-.53-4.27-1.7-6.2-2.96a9.27 9.27 0 0 1-2.84-2.94Zm9.73-9.46-.01.4c-.02.2-.19 1.98-.17 2.57l.07 2.02v.75c-.05.93-.07 1.85-.05 2.78.01.29.03.56-.06.85-.07.27-.28.5-.42.53-.14.03-.43.08-.88.08-.44 0-.76-.02-1.01-.08h-.03c-.17-.04-.36-.08-.59-.48-.36-.62-.71-1.32-1-1.99l-.23-.48-.11-.25a64 64 0 0 1-.74-1.6l-.05.15c0 .39.01.76.03 1.13l.04.97c0 .12.03.38.06.67.04.38.09.81.08.98-.03.28-.21.85-.39.9-.14.04-.28.05-.44.05-.13 0-.27 0-.43.03-.41.07-1 0-1.18-.08-.14-.06-.22-.33-.3-.65l-.06-.16c-.07-.25 0-.95.05-1.54.03-.33.06-.63.05-.77-.03-.6 0-3.41 0-4.23.01-.55 0-.95-.02-1.46l-.01-.29c-.02-.46 0-.56.53-.57.33 0 .66-.11.99-.22.33-.11.67-.22 1-.22.56.01.56.01.77.53.04.1.08.25.1.4l.08.29c.32.92.7 1.83 1.08 2.73l.45 1.06.05.06.05.07c.06-.05.06-.11.06-.16v-.02l-.01-.96c0-.64 0-1.27-.06-1.92-.03-.41-.04-.7-.05-1.06v-.28c0-.16.26-.34.44-.38l.05-.02c.28-.07 1.22-.33 1.86-.33l.25.02c.08.02.16.12.16.18Zm5.47 6.83c.05.33.05.66.02.99a.38.38 0 0 1-.35.12h-.13c-.16 0-.33.01-.48-.04-.53-.18-.9-.54-1-1.11-.1-.5-.14-2.89-.07-3.14.12-.45.3-.9.52-1.32a.5.5 0 0 1 .35-.27l.3-.06c.24-.03.44.06.57.26l.08.12.06.09c.17.28.3.57.4.87l.14.34c.06.1.2.16.31.13.58-.14 1.05-.43 1.28-1.03.29-.74.21-1.4-.34-1.98-.17-.18-.36-.33-.54-.49l-.19-.15a1.37 1.37 0 0 0-.94-.34c-.34 0-.68 0-1.02.02-.41.02-.82.1-1.19.28-.43.21-.81.5-1.19.8-.2.16-.39.36-.51.6l-.13.24c-.31.53-.81 1.4-.81 3.2 0 2.04.45 2.87.69 3.3l.01.04.08.14c.4.76.41.78 1.44 1.39.32.2.68.3 1.06.3l.4.01h.78c.79-.03 1.49-.29 2.1-.78l.4-.32a.81.81 0 0 0 .36-.74v-1.5l-.01-1.34-.01-.26a.32.32 0 0 0-.3-.3l-.36-.01c-.47 0-.92-.01-1.38-.06-.36-.04-.72-.04-1.08-.04-.2-.01-.4.02-.6.1-.14.05-.2.13-.2.27-.01.46.14.84.5 1.12.2.16.42.3.65.4l.1.05.23.1Z"
        fill={darkMode ? white : main}
      />
    </svg>
  );
};

export default NonGluten;
